import { LogService } from 'library/ts/utilities/logger/LogService';
export class ConfigUtilities {
    static getConfigs = (uuid, config, onSuccess, onFailure) => {
        const utils = window.SmartTag.utilities;
        const logger = LogService.create({ prefixes: ['SmartTag:', 'Tag:', uuid] });
        const requestData = (configsArrayItem) => {
            return new Promise((resolve, reject) => {
                if (utils.Type.isString(configsArrayItem) && utils.URL.valid(configsArrayItem)) {
                    fetch(configsArrayItem)
                        .then((response) => {
                        return response.text();
                    })
                        .then((data) => {
                        resolve(data ? JSON.parse(data) : {});
                    })
                        .then((data) => {
                        logger.log('getConfigs:', 'Fetch success:', data);
                        resolve(data);
                    })
                        .catch((error) => {
                        logger.warn('getConfigs:', 'Fetch error:', error);
                    })
                        .finally(() => {
                        logger.log('getConfigs:', 'Fetch finally:', 'Resolve with empty object.');
                        resolve({});
                    });
                }
                if (utils.Type.isObject(configsArrayItem) || utils.Type.isJSON(configsArrayItem)) {
                    resolve(configsArrayItem);
                }
            });
        };
        const processConfigsArray = (configsArray) => {
            return configsArray.reduce((promise, configsArrayItem, index) => {
                return promise.then((results) => {
                    return requestData(configsArrayItem).then((data) => {
                        results.push(data);
                        return results;
                    });
                });
            }, Promise.resolve([]));
        };
        const processConfigSection = (section, sectionConfigsArray) => {
            if (utils.Type.isUndefined(sectionConfigsArray)) {
                sectionConfigsArray = [];
            }
            else {
                if (!utils.Type.isArray(sectionConfigsArray)) {
                    sectionConfigsArray = [sectionConfigsArray];
                }
            }
            return new Promise((resolve) => {
                logger.log('\ngetConfigs:', '\nProcessing:', '\nSection:', section, '\nSection configs array:', sectionConfigsArray, '\Configs:', sectionConfigsArray.length, '\nStart iterating over section configs', '\n----------------');
                processConfigsArray(sectionConfigsArray).then((configs) => {
                    resolve({
                        section: section,
                        configs: configs
                    });
                });
            });
        };
        Promise.all(Object.keys(config).map((section) => {
            return processConfigSection(section, config[section]);
        })).then((result) => {
            logger.log('getConfigs:', 'Done:\nResults:', result, '\nConfig:', config);
            const outputConfig = {};
            result.forEach((item) => {
                outputConfig[item.section] = item.configs.reduce((acc, obj) => utils.DeepMerge.deepmerge(acc, obj, undefined), {});
            });
            logger.log('getConfigs:', 'Config flattened:', outputConfig);
            if (utils.Type.isFunction(onSuccess))
                onSuccess(outputConfig);
        });
    };
}
